// extracted by mini-css-extract-plugin
export default {"overlayContainer":"CreateOrEditAssignment__overlayContainer___kceft","createAssignmentButton":"CreateOrEditAssignment__createAssignmentButton___JnXX2"};